// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__11MRq","calendarButtons":"ClockData_calendarButtons__1ihCh"};